var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('QuoteDetail',{attrs:{"quoteId":_vm.quoteId,"quoteRevision":_vm.quoteRevision}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }